import Button from "kustom-front/src/components/atoms/Button";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ScreenParams } from "@Types/login";
import "./style.scss";

interface Props {
  onChangeScreen: (newScreenParams: ScreenParams) => void;
  params: ScreenParams;
}

const Forgotten: FunctionComponent<Props> = ({ onChangeScreen, params }) => {
  const intl = useIntl();

  return (
    <div className="Forgotten">
      <div className="Forgotten-title">
        {intl.formatMessage({ id: "cheerz_LoginModal_forgotten_title" })}
      </div>
      <span>
        {intl.formatMessage({ id: "cheerz_LoginModal_forgotten_rule_1" }, { email: params.email })}
      </span>
      <span>{intl.formatMessage({ id: "cheerz_LoginModal_forgotten_rule_2" })}</span>
      <span>{intl.formatMessage({ id: "cheerz_LoginModal_forgotten_rule_3" })}</span>
      <Button
        onClick={() =>
          onChangeScreen({
            action: "signIn",
            email: params.email,
            screen: "password",
          })
        }
        type="primary"
      >
        {intl.formatMessage({ id: "cheerz_LoginModal_forgotten_button" })}
      </Button>
    </div>
  );
};

export default Forgotten;
